/**
 * StatisticsPaymentsMethod
 * --
 */
// import React from 'react';
import { Descriptions, Table, Button } from 'antd';
import { Content, Col } from 'components';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';
import { ORDER_ROUTE, ORDER_STATUS } from 'constants/OrderConstants';
/* 

결제수단별 매출 : 사용중인 필드
  payment_type: 결제수단
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용금액
  usePointAmount: 포인트
*/

/**----------------------------------------
 * [Component] 메뉴별 매출
 * ----------------------------------------
 */
const StatisticsPaymentsMethod = ({
  headerData,
  data, // 차트 데이터
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  // startDate,
  // endDate,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const columns = [
    {
      title: '주문번호',
      dataIndex: 'order_number',
      width: 90,
      align: 'center',
    },
    {
      title: '결제수단',
      dataIndex: 'order_route',
      width: 150,
      align: 'center',
      filters: Object.entries(ORDER_ROUTE).map(([key, v]) => ({
        text: v.label,
        value: key,
      })),
      onFilter: (value, record) => record.order_route.includes(value),
    },
    {
      title: '결제금액',
      dataIndex: 'final_price',
      width: 130,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.final_price - b.final_price,
    },
    {
      title: '할인금액',
      dataIndex: 'final_discount',
      width: 120,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.final_discount - b.final_discount,
    },
    {
      title: '사용포인트',
      dataIndex: 'use_point',
      width: 170,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.use_point - b.use_point,
    },
    {
      title: '적립금',
      dataIndex: 'final_reward_point',
      width: 140,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.final_reward_point - b.final_reward_point,
    },
    {
      title: '쿠폰',
      dataIndex: 'coupon_info',
      width: 80,
      render: (v) => (
        <div style={{ textAlign: 'right' }}>
          {v ? stringToMoneyFormat(v.length) : '0'}
        </div>
      ),
      sorter: (a, b) => a.coupon_info?.length - b.coupon_info?.length,
    },
    {
      title: '주문시간',
      dataIndex: 'created_at',
      width: 110,
      align: 'center',
      render: (v) => moment(v * 1000).format('HH:mm:ss'),
      sorter: (a, b) => a.created_at - b.created_at,
    },
    {
      title: '주문상태',
      dataIndex: 'order_status',
      width: 125,
      align: 'center',
      filters: Object.entries(ORDER_STATUS).map(([key, v]) => ({
        text: v.label,
        value: key,
      })),
      onFilter: (value, record) => record.order_status.includes(value),
    },
    {
      title: '상세내역',
      dataIndex: 'product_information',
      width: 450,
      render: (v) => (
        <div>
          <table
            style={{
              border: 'none',
              padding: 0,
              fontSize: '0.9em',
              lineHeight: 1,
            }}
          >
            {v.map((item) => {
              return (
                <tr>
                  <td>
                    {/* == 메뉴명 == */}
                    <p>
                      <b>- {item.menu_name}</b>
                    </p>
                    {/* == 옵션목록 == */}
                    {item?.menu_option?.length > 0 ? (
                      <ul
                        style={{
                          padding: 3.5,
                          background: '#f7f7f7',
                          maxHeight: 58,
                          overflowY: 'scroll',
                        }}
                        className="custom-scroll"
                      >
                        {item?.menu_option?.map((menuOption, ind) => (
                          <li
                            key={`akwossll${ind}`}
                            style={{
                              fontSize: '0.9em',
                              paddingLeft: 2.5,
                              borderLeft: '1px solid #333',
                            }}
                          >
                            옵션) {menuOption.option_title}
                            {menuOption?.option?.map((op, op_ind) => (
                              <p
                                key={`w0odmm${op_ind}`}
                                style={{ fontSize: '0.95em' }}
                              >
                                - {op.option_name}{' '}
                                {menuOption.type === 'DEFAULT'
                                  ? `(필수)`
                                  : `(${op.count})`}
                              </p>
                            ))}
                          </li>
                        ))}
                      </ul>
                    ) : null}
                  </td>
                  <td style={{ textAlign: 'right' }}>{item.num}개</td>
                  <td style={{ textAlign: 'right', width: 85 }}>
                    {stringToMoneyFormat(item.price * item.num)}원
                  </td>
                </tr>
              );
            })}
          </table>
        </div>
      ),
    },
    {
      title: '쿠폰내역',
      dataIndex: 'coupon_info',
      width: 380,
      render: (v) =>
        v && (
          <div>
            <table
              style={{
                border: 'none',
                padding: 0,
                fontSize: '0.9em',
                lineHeight: 1,
              }}
            >
              {v.map((item) => (
                <tr>
                  <td>- {item.coupon_name}</td>
                  <td style={{ textAlign: 'right', width: 85 }}>
                    {stringToMoneyFormat(item.discount_price)}원
                  </td>
                </tr>
              ))}
            </table>
          </div>
        ),
    },
  ];
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // console.log('headerData: ', headerData);

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <div style={{ background: '#fff' }}>
          {headerData && (
            <Descriptions
              className="boxShadow"
              // title="User Info"
              size="small"
              layout="vertical"
              column={7}
              bordered
              style={{ width: '100%' }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '날짜',
                  contentStyle: { textAlign: 'center' },
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{moment(headerData.date).format('YYYY-MM-DD(ddd)')}</p>
                  ),
                },
                {
                  key: 'totalAmount',
                  label: '총매출',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{stringToMoneyFormat(Number(headerData.totalAmount))}</p>
                  ),
                },
                {
                  key: 'netSales',
                  label: '순매출',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        Number(headerData.totalAmount) -
                          Math.abs(headerData.discountAmount) -
                          Math.abs(headerData.usePointAmount)
                      )}
                    </p>
                  ),
                },
                {
                  key: 'paymentCount',
                  label: '주문건수',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{stringToMoneyFormat(headerData.paymentCount)}</p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{stringToMoneyFormat(headerData.discountAmount)}</p>
                  ),
                },
                {
                  key: 'usePointAmount',
                  label: '사용포인트',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{stringToMoneyFormat(headerData.usePointAmount)}</p>
                  ),
                },
                {
                  key: 'refundAmount',
                  label: '환불금액',
                  style: { width: `${(100 / 7).toFixed(4)}%` },
                  children: (
                    <p>{stringToMoneyFormat(headerData.refundAmount)}</p>
                  ),
                },
              ]}
            />
          )}
        </div>
        <br />
        <Col x={24} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() =>
              downloadXlsx({
                columns: columns?.map((column) => {
                  if (column?.title === '쿠폰내역') {
                    column.dataIndex = 'coupon_info_detail';
                  }
                  return column;
                }),
                rows: data?.map((_item) => {
                  const { coupon_info, product_information } = _item;
                  return {
                    ..._item,
                    product_information: product_information
                      ?.map((menu) => {
                        return `메뉴명: ${menu?.menu_name}, 수량: ${
                          menu?.num
                        }, 금액: ${stringToMoneyFormat(
                          menu.price * menu.num
                        )}원`;
                      })
                      .join('\n'),
                    coupon_info: coupon_info?.length ?? 0,
                    coupon_info_detail: coupon_info
                      ?.map((coupon) => {
                        return `쿠폰명: ${
                          coupon?.coupon_name
                        }, 할인금: ${stringToMoneyFormat(
                          coupon?.discount_price
                        )}원`;
                      })
                      .join('\n'),
                  };
                }),
                fileName: '일자별_상세내역_리포트',
              })
            }
          >
            엑셀로 다운로드
          </Button>
        </Col>
        <br />

        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            // style={{ minWidth: 1500 }}
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            columns={columns}
            scroll={{
              // x: 'max-content',
              x: 1140,
            }}
            style={{ minHeight: 580 }}
            // rowClassName={'cancel-row'}
            rowClassName={(record) =>
              record.order_status === 'CANCELLED' ? 'cancel-row' : ''
            }
          />
        </div>
      </Content>
    </>
  );
};

StatisticsPaymentsMethod.defaultProps = {
  headerData: null,
};
export default StatisticsPaymentsMethod;
